module.exports = __webpack_public_path__ + "img/DE02457.efea8b71.png";